import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import style from './styles/style.module.css';
import { Field, reduxForm, Form } from 'redux-form';
import { PrimaryButton } from 'appSrc/components/UI';
import { FormTextField } from 'appSrc/components/UI/ReduxForm';

class TagForm extends PureComponent {
    constructor(props) {
        super(props);
    }
    submit = ( values ) => {
        this.props.next( values );
    }
    render() {
        const { handleSubmit } = this.props;
        return (
            <Form
            className={ style.tagForm }
            onSubmit={ handleSubmit( this.submit ) }>
                <Field
                name="tagtext"
                label="Name"
                component={ FormTextField }
                fullWidth />

                <PrimaryButton
                label="Submit"
                fullWidth
                type="submit"
                style={ { marginTop: '15px' } }/>
            </Form>
        );
    }
}

TagForm = reduxForm( {
    form: 'TagForm',
} )( TagForm );


export default connect()( TagForm );
